// eslint-disable-next-line import/prefer-default-export
export const replaceCreator = (replaceStr = '--', processor = null) => value => {
  if (value === null || value === undefined) {
    return replaceStr;
  }

  return processor ? processor(value) : value;
};
